import isEmail from 'validator/es/lib/isEmail';
import isPostalCode from 'validator/es/lib/isPostalCode';
//@ts-expect-error
import passwordValidator from 'password-validator';
const passwordSchema = new passwordValidator();
import moment from 'moment-timezone';
// Add properties to it
passwordSchema
  .is()
  .min(8) // Minimum length 8
  .is()
  .max(100) // Maximum length 100
  .has()
  .uppercase() // Must have uppercase letters
  .has()
  .lowercase() // Must have lowercase letters
  .has()
  .digits() // Must have digits
  .has()
  .not()
  .spaces(); // Should not have spaces

class ValidatorUtils {
  checkIsEmail(value: string = ''): boolean {
    return isEmail(value);
  }

  validateEmail(value: string = ''): string | undefined {
    if (!this.checkIsEmail(value.trim())) return 'Invalid email';
  }

  validateUsername(value: string = ''): string | undefined {
    if (value.length < 4 || value.length > 64 || !/^[A-Za-z0-9@._]+$/.test(value))
      return 'Username must have at least 4 alphanumeric characters';
  }

  validatePassword(value: string = ''): string | undefined {
    if (!passwordSchema.validate(value))
      return 'Use at least 8 characters, an uppercase letter, a lowercase letter, and a number';
  }

  validatePostcode(value: string = ''): string | undefined {
    if (!isPostalCode(value, 'CA')) return 'Please use a valid Canadian postcode format';
  }

  validateVerificationCode(value: string = ''): string | undefined {
    if (!this.isInt(value) || value.length !== 6) return 'Code should have 6 numeric characters';
  }

  validateOhip(value: string = ''): string | undefined {
    value = value.replace(/ /g, '').trim();
    if (value.length < 10 || value.length > 12) return 'OHIP must have 10 digits and 2 letters';

    let number = value.substring(0, 10);
    if (!this.isInt('' + number)) return 'First 10 digits must be only numbers';
  }

  stringMatchesDate(value: string = '', format: string): boolean {
    return moment(value, format).format(format) === value;
  }

  isInt(value: string = ''): boolean {
    return /^\+?(|[0-9]\d*)$/.test(value);
  }

  isDollarAmount(value: string = ''): boolean {
    return this.isInt(value.replace('.', '').replace(',', ''));
  }
}

export default new ValidatorUtils();
